//reducers
import { selectImageUrl, selectTranslations } from 'state/reducers/translation.reducers';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import Add from '@mui/icons-material/Add';
//theme
import { HeaderPage1 } from 'theme/elements/Headers';
import { Stack, Button, Box, Divider } from '@mui/material';
import { FormButton, GeneralButton } from 'theme/elements/Buttons';
import { useNavigate } from 'react-router-dom';
import { toggleUpserting } from 'state/reducers/beneficiary.reducers';
import { pagesEnum } from 'constants/ui.constants';
import { UserPermission } from 'constants/user.constants';
import _ from 'lodash';
import { getMobile, togglePage } from 'state/reducers/ui.reducers';

export default function Header(props: { userPermission: UserPermission }) {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const imageUrl = useAppSelector(selectImageUrl);
	const isMobile = useAppSelector(getMobile);
	const t = useAppSelector(selectTranslations);
	return (
		<Stack
			justifyContent={'space-between'}
			direction={{ xs: 'column', sm: 'row' }}
			spacing={{ xs: 2, sm: 0 }}
			divider={isMobile && <Divider orientation="horizontal" flexItem />}
		>
			<Box>
				<HeaderPage1 title={t('page.beneficiary.dashboard.title')} />
			</Box>
			{_.includes([UserPermission.OPERATIONER, UserPermission.SIGNER], props.userPermission) && (
				<Box>
					<FormButton>
						<GeneralButton height="inherit">
							<Button
								variant="contained"
								fullWidth={isMobile}
								onClick={() => {
									dispatch(toggleUpserting(true));
									dispatch(togglePage(`/${pagesEnum.BENEFICIARY}/new`));
								}}
								startIcon={
									imageUrl('page.beneficiary.dashboard.add_button.icon') || (
										<Add
											sx={{
												'&.MuiSvgIcon-root': { height: '24px', width: '24px' },
											}}
										/>
									)
								}
							>
								{t('page.beneficiary.dashboard.add_button.text')}
							</Button>
						</GeneralButton>
					</FormButton>
				</Box>
			)}
		</Stack>
	);
}
